import React from 'react';
import { FileText, MessageSquare, FileCheck, Code, Rocket } from 'lucide-react';
import './HowItWorks.css';

const stepsData = [
  {
    icon: <FileText size={36} />,
    number: '01',
    title: 'Share Requirement',
    description: 'Tell us about your project needs, timeline, and expectations'
  },
  {
    icon: <MessageSquare size={36} />,
    number: '02',
    title: 'Free Discussion & Estimate',
    description: 'Quick call to understand scope and provide transparent pricing'
  },
  {
    icon: <FileCheck size={36} />,
    number: '03',
    title: 'NDA + Scope Confirmation',
    description: 'Sign NDA, finalize requirements, and set clear milestones'
  },
  {
    icon: <Code size={36} />,
    number: '04',
    title: 'Development with Weekly Updates',
    description: 'Regular progress reports, demos, and transparent communication'
  },
  {
    icon: <Rocket size={36} />,
    number: '05',
    title: 'Delivery, Support & Scaling',
    description: 'Smooth handoff, ongoing support, and partnership growth'
  }
];

const HowItWorks = () => {
  return (
    <section className="how-it-works-section" id="process">
      <div className="how-it-works-container">
        <div className="how-it-works-header">
          <h2 className="section-title">How It Works</h2>
          <p className="section-description">
            Simple, transparent process from first contact to long-term partnership
          </p>
        </div>
        
        <div className="steps-container">
          {stepsData.map((step, index) => (
            <div key={index} className="step-card">
              <div className="step-number">{step.number}</div>
              <div className="step-icon">{step.icon}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
              {index < stepsData.length - 1 && <div className="step-connector"></div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;